import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import { API_BASE } from './utils/constants';
import { Navigate } from "react-router-dom";
import { authHeader } from './utils/api';
import { httpErrorHandler } from "./utils/httpErrorHandler";
import useSnackbar from '@/hooks/useSnackbar'
import ProtectedRoute from "./router/ProtectedRoute";
import {
  SocketProvider,
} from "./providers/SocketProvider";

import LoginPage from "./views/LoginPage";
import SignUpPage from "./views/SignUpPage"
import ChatUI from "./components/ChatUI";
import ProfilePage from "./views/ProfilePage";

function App() {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	const { showSnackbar } = useSnackbar();

	const fetchUser = async () => {
		try {
			const headers = authHeader();

			const checkRes = await axios.get(
				`${API_BASE}/auth/check-token`,
				{ headers }
			);

			if (!checkRes.data?.success) {
				showSnackbar('نشست شما منقضی شده است. لطفاً دوباره وارد حساب خود شوید.', { type: 'error' })
				throw new Error("Invalid token");
			} else {
				sessionStorage.setItem("token_checked", "true");
			}

			const userRes = await axios.get(
				`${API_BASE}/user/get-me`,
				{ headers }
			);

			if (userRes.data?.success) {
				const user_data = userRes.data.user
				setUser(user_data);
				sessionStorage.setItem(
					"user_data",
					JSON.stringify({
						_id: user_data._id,
						role: user_data.role,
						full_name: user_data.full_name,
						email: user_data.email
					})
				);

				localStorage.setItem("user_id", user_data?._id);
			}
		} catch (err) {
			httpErrorHandler({
				err,
				setSnackbar: (s) =>
					showSnackbar(s?.message || "", { type: s?.type || "error" }),
			});
		} finally {
			setLoading(false);
		}
	};


	useEffect(() => {
		const checked = sessionStorage.getItem("token_checked");
		const user_data = JSON.parse(sessionStorage.getItem("user_data"))

		if (!checked) {
			const token = localStorage.getItem("token");

			if (token) {
				fetchUser()

			} else {
				localStorage.removeItem("user_id");
				setLoading(false);
			}
		} else if (user_data) {
			setUser(user_data)
			setLoading(false)
		} else {
			fetchUser()
			setLoading(false)
		}

	}, []);

	if (loading) {
		return <div style={{ textAlign: 'center', marginTop: '300px' }}>در حال بارگذاری...</div>;
	}
	return (
		<Router>
			<Routes>
				<Route
					path="/"
					element={
						<Navigate to={user ? "/chat" : "/login"} replace />
					}
				/>
				<Route
					path="/chat"
					element={
						<ProtectedRoute user={user}>
							<SocketProvider>
								<ChatUI
									user={user}
									setUser={setUser}
									onLogout={() => setUser(null)}
								/>
							</SocketProvider>
						</ProtectedRoute>
					}
				/>
				<Route
					path="/login"
					element={
						user
							? <Navigate to="/chat" replace />
							: <LoginPage fetchUser={fetchUser} onLogin={(userData) => setUser(userData)} />
					}
				/>
				<Route
					path="/signup"
					element={
						user
							? <Navigate to="/chat" replace />
							: <SignUpPage onRegister={(userData) => setUser(userData)} />
					}
				/>
				<Route
					path="/profile"
					element={
						<ProtectedRoute user={user}>
							<ProfilePage user={user} />
						</ProtectedRoute>
					}

				/>
				<Route
					path="*"
					element={<Navigate to="/" replace />}
				/>
			</Routes>
		</Router>
	);
}

export default App;
